/**
 * Cooking Conversion Calculator - Convert recipe measurements with step-by-step breakdowns
 * @module CookingConversionCalculator
 */
(function() {
    'use strict';

    /**
     * Initialize the calculator
     */
    function init() {
        handleResultCardScroll();
    }

    /**
     * Scroll to conversion result card when page loads after submission
     */
    function handleResultCardScroll() {
        const resultCard = document.getElementById('conversion-result');
        if (resultCard && typeof resultCard.scrollIntoView === 'function') {
            window.requestAnimationFrame(function() {
                resultCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
        }
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // Expose public API
    window.CookingConversionCalculator = {
        handleResultCardScroll: handleResultCardScroll
    };
})();
